import React from "react";
import type { PendingReview } from "../../../chat/hooks/useStreamingTurn";
import { EmailApprovalCard } from "./EmailApprovalCard";
import { PromoteApprovalCard } from "./PromoteApprovalCard";
import { TimesheetApprovalCard } from "./TimesheetApprovalCard";

export interface ToolApprovalCardProps {
  review: PendingReview;
  onDecide: (decision: "approve" | "reject") => void | Promise<void>;
}

/** The approval card for whichever gated tool the turn stopped on. Each gated
 *  tool needs its own card: an email-shaped frame around another call would
 *  describe something other than what approving runs. */
export function ToolApprovalCard({ review, onDecide }: ToolApprovalCardProps) {
  if (review.tool_name === "promote_to_knowledge") {
    return <PromoteApprovalCard review={review} onDecide={onDecide} />;
  }
  // Matched on the segment after the last "__", not the whole name. MCP tools
  // arrive under a catalog name (timesheet__elas__save_timesheet_entries_bulk)
  // whose prefix depends on which plugin exposed them, and six plugins expose
  // the elas server. Exact matching works for in-process fn-tools like
  // promote_to_knowledge; it would miss every MCP tool. Same rule as is_gated.
  if (upstreamName(review.tool_name).includes("timesheet")) {
    return <TimesheetApprovalCard review={review} onDecide={onDecide} />;
  }
  return <EmailApprovalCard review={review} onDecide={onDecide} />;
}

/** The tool's own name, with any `<plugin>__<server>__` catalog prefix dropped. */
function upstreamName(toolName: string): string {
  const i = toolName.lastIndexOf("__");
  return i === -1 ? toolName : toolName.slice(i + 2);
}
